import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const IconChevron = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: '1px', width: '16px', marginLeft: '4px', height: '16px', marginRight: '-1px' }}><path d="M6 9l6 6 6-6"></path></svg>
);

const IconCheck = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);

function SettingsDropdown({ value, options, onSelect }) {
    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });

    const current = options.find((o) => o.value === value) || options[0];

    // The menu is fixed-position: flip above the button when it would
    // overflow the viewport, and close on scroll/resize so it never
    // detaches from its anchor.
    useEffect(() => {
        if (!isOpen) return;

        if (menuRef.current && btnRef.current) {
            const menuRect = menuRef.current.getBoundingClientRect();
            const btnRect = btnRef.current.getBoundingClientRect();
            if (menuRect.bottom > window.innerHeight - 10) {
                const flippedTop = btnRect.top - menuRect.height - 6;
                setMenuPos((p) => ({ ...p, top: Math.max(10, flippedTop) }));
            }
        }

        const handleResize = () => setIsOpen(false);
        // Capture-phase listener sees ALL scrolls, including the menu's own
        // overflow scrolling — only page scrolls should close the menu.
        const handleScroll = (e) => {
            if (menuRef.current && menuRef.current.contains(e.target)) return;
            setIsOpen(false);
        };
        window.addEventListener('resize', handleResize);
        document.addEventListener('scroll', handleScroll, true);
        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('scroll', handleScroll, true);
        };
    }, [isOpen]);

    const handleButtonClick = () => {
        if (!isOpen && btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect();
            // left = button's right edge; CSS translateX(-100%) right-aligns the menu.
            setMenuPos({ top: rect.bottom + 5, left: rect.right });
        }
        setIsOpen((state) => !state);
    };

    return (
        <React.Fragment>
            <button
                ref={btnRef}
                type="button"
                className={`settings-row-btn ${isOpen ? 'open' : ''}`}
                onClick={handleButtonClick}
            >
                {current?.label}
                <IconChevron />
            </button>

            {isOpen && ReactDOM.createPortal(
                <React.Fragment>
                    <div
                        className="settings-select-menu-overlay"
                        onClick={() => setIsOpen(false)}
                    ></div>
                    <div
                        ref={menuRef}
                        className="settings-select-menu"
                        style={{ top: `${menuPos.top}px`, left: `${menuPos.left}px` }}
                    >
                        {options.map((option) => (
                            <div className="control" key={String(option.value)}>
                                <button
                                    className={`control-button ${option.value === value ? 'selected' : ''}`}
                                    type="button"
                                    onClick={() => {
                                        onSelect(option.value);
                                        setIsOpen(false);
                                    }}
                                >
                                    <span className="settings-select-menu-label">{option.label}</span>
                                    {option.sub ? <span className="settings-select-menu-sub">{option.sub}</span> : null}
                                    {option.value === value ? <span className="settings-select-menu-check"><IconCheck /></span> : null}
                                </button>
                            </div>
                        ))}
                    </div>
                </React.Fragment>,
                document.body
            )}
        </React.Fragment>
    );
}

export default SettingsDropdown;
